import ModuleBase from '../../classes/ModuleBase';
import Vue from 'vue';

import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect)

export default new ModuleBase({
    name: 'Common'
});